// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"49":"b95ef428","567":"f85bec90"}[chunkId] + ".js";
};